import { cn } from '@/lib/utils'

/** Placeholder block used while a card or table is loading. */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-[var(--color-border)]', className)}
      {...props}
    />
  )
}
